var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLoadingNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 2,
    height: 4,
    fill: "#030712",
    transform: "rotate(0 12 12)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 2,
    height: 4,
    fill: "#030712",
    transform: "rotate(36 12 12)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 2,
    height: 4,
    fill: "#030712",
    transform: "rotate(72 12 12)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 2,
    height: 4,
    fill: "#030712",
    transform: "rotate(108 12 12)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 2,
    height: 4,
    fill: "#030712",
    transform: "rotate(144 12 12)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 2,
    height: 4,
    fill: "#030712",
    transform: "rotate(180 12 12)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 2,
    height: 4,
    fill: "#030712",
    transform: "rotate(216 12 12)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 2,
    height: 4,
    fill: "#030712",
    transform: "rotate(252 12 12)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 2,
    height: 4,
    fill: "#030712",
    transform: "rotate(288 12 12)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 2,
    height: 4,
    fill: "#030712",
    transform: "rotate(324 12 12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLoadingNotification);
export default __webpack_public_path__ + "static/media/ic-loading-notification.449e9ee622c7cd070698e38093180fb5.svg";
export { ForwardRef as ReactComponent };